
export default {
  name: 'LocationsSearchContainer'
}
